import { defineMessages } from "@/i18n";
import en from "./en";

export const desktopVoiceMessages = defineMessages("desktop-voice", en);
